import React from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Button, Popconfirm, Message } from 'antd'
import { fetchDeletedTable, postEnabledTable } from '../../api/clubTable'
import moment from 'moment'

class ClubDeletedTable extends React.Component {
  state = {
    tableList: [],
  }

  componentDidMount() {
    this.getDeletedTable()
  }

  // 获取已删除球台
  getDeletedTable = async () => {
    const { data, status, detail } = await fetchDeletedTable({
      clubId: sessionStorage.getItem('club_id'),
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    let newData = data.map(item => {
      item.firm_type = (item.firm_type === '桌球') ? '台球' : item.firm_type
      return item
    })
    this.setState({
      tableList: newData,
    })
  }

  // 恢复球台
  restoreTable = async (tableId) => {
    const { data, status, detail } = await postEnabledTable({
      tableId,
    })
    if (status != 1) {
      Message.error(detail)
      return
    }
    Message.success(detail)
    this.getDeletedTable()
  }

  render() {
    const { tableList } = this.state

    const columns = [
      {
        title: '桌台编号',
        dataIndex: 'order_num',
      },
      {
        title: '灯箱编号',
        dataIndex: 'table_number',
      },
      {
        title: '桌台名称',
        dataIndex: 'group_name',
      },
      {
        title: '分组',
        dataIndex: 'type_name',
      },
      {
        title: '类型',
        dataIndex: 'firm_type',
      },
      {
        title: '价格[元/小时]',
        dataIndex: 'hour_price',
      },
      {
        title: '删除日期',
        dataIndex: 'update_time',
      },
      {
        title: '操作者',
        dataIndex: 'operator',
      },
      // {
      //   title: '操作',
      //   dataIndex: 'edit',
      //   render: (text, record, index) => {
      //     return (
      //       <div style={{ cursor: 'default' }}>
      //         <Popconfirm
      //           title={'你确认要恢复' + record.group_name + '吗?'}
      //           okText="确认"
      //           cancelText="取消"
      //           onConfirm={() => {
      //             this.restoreTable(record.table_id)
      //           }}
      //         >
      //           <Button type="primary">恢复</Button>
      //         </Popconfirm>
      //       </div>
      //     )
      //   },
      // },
    ]

    return (
      <div>
        <Table
          rowKey="table_id"
          center
          bordered
          columns={columns}
          dataSource={tableList}
          // pagination={{
          //   current: currentPage,
          //   pageSize: pageSize,
          //   total: totalCount,
          //   onChange: this.paginationChange,
          //   onShowSizeChange: this.paginationSizeChange,
          // }}
        />
      </div>
    )
  }
}

export default withRouter(ClubDeletedTable)



// WEBPACK FOOTER //
// ./src/containers/ClubDeletedTable/index.js